export const SET_AUDIO_QUALITY = 'Web.PlaybackInterface.v1_0.SetAudioQualityMethod';
export const UPDATE_ABR_SETTING = 'Web.PlaybackInterface.v1_0.UpdateABRSettingMethod';
export const INITIATE_AUDIO_SETTING = 'Web.PlaybackInterface.v1_0.InitiateAudioSettingMethod';
